import React from "react";
import { Typography } from "@mui/material";

function Policy(props) {
  const { policyData } = props;

  const renderListItems = (title,content) => {
    return content.map((item, index) => (
      <li key={index} className={`${props?.name ==='privacyPolicy' ? 'colorLightBlack' : ''}`}> {props.subsection !== 'term' ? <span className='font16 fw500'>{title}</span> : null} { item}</li>
    ));
  };

  return (
    <div className="customerPolicyLayout">
      {policyData.map((item, index) => (
          <div key={index}>
            <p className={props.className ? props.className : 'subpolicyTitle'}>{item.title}</p>
            {item.body.map((subItem, subIndex) => (
              <div key={subIndex} className="policyDescription">
                <ul>
                  {renderListItems(subItem.subTitle , subItem.content)}
                </ul>
              </div>
            ))}
          </div>
        ))}
    </div>
  );
}

export default Policy;
